exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "video#wipo-player[data-v-55e0345c]{width:100%;height:360px;background-color:#000}@media screen and (max-width:767px){video#wipo-player[data-v-55e0345c]{width:100%;height:auto;background-color:#192538}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-55e0345c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Player.vue
// module id = 44
// module chunks = 0